import PDFDocument from 'pdfkit/js/pdfkit.standalone.js';
import { COLOR_BLACK, FONT, FONT_SIZE_SMALL } from '../variables';

export function renderFooter(pdf: PDFDocument, body: any) {
	const margin = 42.5;

	const renderPage = (pageNumber: number, pages: number) => {
		const resetBottom = pdf.page.margins.bottom;

		pdf.page.margins.bottom = 0;

		if (body.copyright) {
			pdf.font(FONT)
				.fontSize(FONT_SIZE_SMALL)
				.fillColor(COLOR_BLACK)
				.text(body.copyright, pdf.page.margins.left + 21.5, pdf.page.height - pdf.page.margins.bottom - margin);
		}

		pdf.font(FONT)
			.fontSize(FONT_SIZE_SMALL)
			.fillColor(COLOR_BLACK)
			.text(
				`${body.pageLabel} ${pageNumber}/${pages}`,
				pdf.page.width - pdf.page.margins.right - 100,
				pdf.page.height - pdf.page.margins.bottom - margin,
				{
					width: 100,
					align: 'right',
					lineBreak: false
				}
			);

		// reset text writer position
		pdf.text('', 50, margin);

		pdf.page.margins.bottom = resetBottom;
	};

	const range = pdf.bufferedPageRange();
	const end = range.start + range.count;

	for (let i = range.start; i < end; i++) {
		pdf.switchToPage(i);

		renderPage(i + 1, range.count);
	}

	pdf.flushPages();
}
